<!-- formatted-content component
  - 2025.07.17
  - Vue 3 component based on WeChat mini program formatted-content component
  - Splits content by newlines and renders paragraphs with different behaviors
  - Supports slots for prefixes/suffixes in different modes
  - Props:
    - content: string - The text content to format
    - userSelect: boolean - Whether text is selectable (default: true)
    - nuonMomentComment: boolean - Comment mode with prefix slot (default: false)
    - isNuonMomentVehicleComments: boolean - Vehicle comments mode with suffix slot (default: false)
    - showMoreText: boolean - Reserved for future use (default: false)
  - Slots:
    - nuon-moment-comment-prefix: Prefix content for comment mode
    - nuon-moment-vehicle-comments-suffix: Suffix content for vehicle comments mode
-->
<template>
  <div class="formatted-content-wrapper">
    <template
      v-for="(paragraph, index) in formattedParagraphs"
      :key="index">
      <!-- isNuonMomentVehicleComments -->
      <template v-if="isNuonMomentVehicleComments">
        <template v-if="index === formattedParagraphs.length - 1">
          <div class="formatted-paragraph">
            <span style="display: inline;">{{ paragraph }}...</span>
            <slot name="nuon-moment-vehicle-comments-suffix" />
          </div>
        </template>
        <template v-else>
          <div class="formatted-paragraph">{{ paragraph }}</div>
        </template>
      </template>
      <!--/ isNuonMomentVehicleComments -->

      <!-- nuonMomentComment -->
      <template v-else-if="nuonMomentComment">
        <template v-if="index === 0">
          <div class="formatted-paragraph">
            <slot name="nuon-moment-comment-prefix" />
            <span style="display: inline;">{{ paragraph }}</span>
          </div>
        </template>
        <template v-else>
          <div class="formatted-paragraph">
            {{ paragraph }}
          </div>
        </template>
      </template>
      <!--/ nuonMomentComment -->

      <!-- default -->
      <template v-else>
        <div class="formatted-paragraph">
          {{ paragraph }}
        </div>
      </template>
      <!--/ default -->
    </template>
  </div>
</template>

<script setup>
import {computed} from 'vue'

// defineOptions
// - 2025.07.17
// - Component name definition
defineOptions({
  name: 'FormattedContent',
})

// props
// - 2025.07.17
// - Component props definition
const props = defineProps({
  content: {
    type: String,
    default: '',
  },
  nuonMomentComment: {
    type: Boolean,
    default: false,
  },
  showMoreText: {
    type: Boolean,
    default: false,
  },
  isNuonMomentVehicleComments: {
    type: Boolean,
    default: false,
  },
})

// formattedParagraphs
// - 2025.07.17
// - Computed property to format content into paragraphs
const formattedParagraphs = computed(() => {
  if (!props.content || typeof props.content !== 'string') {
    return []
  }

  return props.content
    .split('\n')
    .map((paragraph) => paragraph.trim())
    .filter((paragraph) => paragraph.length > 0)
})
</script>

<style lang="scss" scoped>
.formatted-content-wrapper {
  // Base wrapper styles
}

.formatted-paragraph {
  display: block;
}

.formatted-paragraph + .formatted-paragraph {
  margin-top: 12px;
}
</style>
